"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.users = users;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _RequestState = _interopRequireDefault(require("lead-flows-ui/utils/RequestState"));

var INITIAL_STATE = {
  users: {
    fetchRequestState: _RequestState.default.NOT_REQUESTED,
    usersList: []
  }
};

function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.users;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.REQUEST_USERS:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.REQUEST_SUBMITTED
      });

    case _ActionTypes.RECEIVE_USERS:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.SUCCESS,
        usersList: action.payload
      });

    case _ActionTypes.ERROR_RETRIEVING_USERS:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.ERROR.withMessage(action.payload)
      });

    case _ActionTypes.REMOVE_USERS_LOADING_ERROR:
      return Object.assign({}, state, {
        fetchRequestState: _RequestState.default.NOT_REQUESTED
      });

    default:
      return state;
  }
}